// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1WolF","column":"style_column__2--iE","row":"style_row__3FVg6"};